<template>
    <div id="overlay">
        <div class="d-flex align-items-center dialog_height">
        <div class='mypage-friend-input mypage-visit-input'>
            <div class="p-2 pb-3">

                <slot></slot>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
/**
 * 無人チェックイン モーダル
 */
import validater from '../../../lib/validater';
export default {
    components: {
        validater
    },
    props:['btnName'],
    data () {
        return {

        };
    },
    created () {
    },
    methods: {
    }
}
</script>

<style scoped>
.dialog_height{
    height: 100%;
}
.mypage-visit-input {
    height: initial;
    max-height: 100vh;
    overflow-y: auto;
}
@media screen and (max-width: 896px) {
    .mypage-visit-input{
        height: 95vh;
        width: 90%;
        margin: 10px auto;
        overflow-y: scroll;
    }
}

</style>
